// History + review for Daily Focus & Weekly Mock.
// Server: student-agent-api/routers/exam_runway_history_router.py.

import api from './api';
import { DrillQuestion } from './aptitudeDrillAPI';

export interface HistoryItem {
  session_id: string;
  type: 'daily_focus' | 'weekly_mock';
  subject: string | null;
  status: string;
  mode: string | null;
  period: string | null;
  total: number;
  answered: number;
  correct: number;
  score_pct: number;
  started_at: string | null;
  completed_at: string | null;
}

export interface ReviewQuestion extends DrillQuestion {
  correct_answer: string;
  explanation: string;
  student_answer: string | null;
  is_correct: boolean;
}

export interface ReviewResponse {
  session_id: string;
  type: string;
  subject: string | null;
  status: string;
  mode: string | null;
  period: string | null;
  total: number;
  correct: number;
  score_pct: number;
  questions: ReviewQuestion[];
  started_at: string | null;
  completed_at: string | null;
}

export const examRunwayAPI = {
  history: async (limit = 50): Promise<{ sessions: HistoryItem[]; count: number }> => {
    const r = await api.get('/student/exam-runway/history', { params: { limit } });
    return r.data;
  },
  sessionDetail: async (sessionId: string): Promise<ReviewResponse> => {
    const r = await api.get(`/student/exam-runway/sessions/${sessionId}`);
    return r.data;
  },
};
